const LOCALES = [
    'cs-CZ',
    'da-DK',
    'de-DE',
    'nl-NL',
    'en-GB',
    'es-ES',
    'fr-FR',
    'it-IT',
    'pl-PL',
    'pt-PT',
    'ro-RO',
];

export default LOCALES;
